module.exports = __webpack_public_path__ + "img/hardness.32469d3.jpg";